import { Step, ProgressSteps } from "baseui/progress-steps";
import { JobType } from "../../../types/jobs";
import { JobTypeFormFields } from "./JobTypeFormFields";
import { JobTypeSkillFields } from "./JobTypeSkillFields";


type Props = {
  jobType?: JobType;
  additionalSteps?: JSX.Element[];
  currentStep: number;
};
export function JobTypeFormSteps({
  currentStep,
  additionalSteps,
  jobType
}: Readonly<Props>) {
  
  const generalDataStep = (
    <Step title="Datos generales">
      <JobTypeFormFields jobType={jobType} />
    </Step>
  );


  const skillStep = (
    <Step title="Habilidades">
      <JobTypeSkillFields />
    </Step>
  );

  const steps = [generalDataStep, skillStep]

  if (additionalSteps) {
    steps.push(...additionalSteps);
  }

  return <ProgressSteps current={currentStep}>{steps}</ProgressSteps>;
}
